# Terms of Service for Intuizen

_Last Updated: July 26, 2024_

## 1. Acceptance of Terms

By accessing or using the Intuizen application ("Intuizen," the "Application,"
or the "Service") provided by Sovilon Software Inc. ("we," "our," "us," or the
"Company"), you agree to be bound by these Terms of Service ("Terms"). If you do
not agree to these Terms, do not use the Application.

## 2. Eligibility

You must be at least 18 years old to use Intuizen. By using the Application, you
represent and warrant that you are at least 18 years of age and have the legal
capacity to enter into these Terms.

## 3. Prohibited Uses

3.1 There may be prohibited uses of intuizen which will be posted here. By using
Intuizen, you confirm that you are not using it for any of the prohibited
purposes.

3.2 You also agree not to use Intuizen: a) In any way that violates any
applicable federal, provincial, local, or international law or regulation.

## 4. User Accounts

4.1 You may need to create an account to use some features of the Application.
You are responsible for maintaining the confidentiality of your account
information and for all activities that occur under your account.

4.2 We reserve the right to refuse service, terminate accounts, remove or edit
content in our sole discretion.

## 5. User-Generated Content and Ownership

5.1 Any data generated by users as part of their usage of the Application is the
sole property of Sovilon Software Inc. By using the Application, you grant us a
worldwide, non-exclusive, royalty-free, perpetual, irrevocable license to use,
reproduce, modify, adapt, publish, translate, create derivative works from,
distribute, and display such content in any media.

5.2 You represent and warrant that you have all necessary rights to grant us
this license for any content you submit or create within the Application.

## 6. Intellectual Property Rights

6.1 The Application and its entire contents, features, and functionality
(including but not limited to all information, software, text, displays, images,
video, and audio, and the design, selection, and arrangement thereof) are owned
by the Company, its licensors, or other providers of such material and are
protected by Canadian and international copyright, trademark, patent, trade
secret, and other intellectual property or proprietary rights laws.

6.2 These Terms permit you to use the Application for your personal,
non-commercial use only. You must not reproduce, distribute, modify, create
derivative works of, publicly display, publicly perform, republish, download,
store, or transmit any of the material on our Application, except as follows: a)
Your computer may temporarily store copies of such materials incidental to your
accessing and viewing those materials. b) You may store files that are
automatically cached by your Web browser for display enhancement purposes.

## 7. Disclaimer of Warranties and Limitation of Liability

7.1 The Application is provided "as is" and "as available" without any
warranties of any kind, either express or implied, including but not limited to
implied warranties of merchantability, fitness for a particular purpose, or
non-infringement.

7.2 To the fullest extent permitted by applicable law, Sovilon Software Inc.,
its officers, directors, employees, and agents exclude all liability for any
damages or losses arising from your use of the Application. This includes,
without limitation, direct, indirect, incidental, consequential, punitive, or
exemplary damages. By using the Application,
you expressly agree to assume all risks associated with such use.

7.3 You expressly understand and agree that your use of the service is at your
sole risk. To the fullest extent provided by law, in no event will the Company,
its affiliates, or their licensors, service providers, employees, agents,
officers, or directors be liable for damages of any kind, under any legal
theory, arising out of or in connection with your use, or inability to use, the
Application, including any direct, indirect, special, incidental, consequential,
or punitive damages.

7.4 Some jurisdictions do not allow the exclusion or limitation of certain
warranties or liability for certain types of damages. Accordingly, some of the
above limitations in this section may not apply to you. In such cases, our
liability will be limited to the fullest extent permitted by applicable law.

## 8. Indemnification

You agree to defend, indemnify, and hold harmless the Company, its affiliates,
licensors, and service providers, and its and their respective officers,
directors, employees, contractors, agents, licensors, suppliers, successors, and
assigns from and against any claims, liabilities, damages, judgments, awards,
losses, costs, expenses, or fees (including reasonable attorneys' fees) arising
out of or relating to your violation of these Terms or your use of the
Application.

## 9. Termination

9.1 We reserve the right to terminate or suspend your account and access to the
Application immediately, without prior notice or liability, for any reason
whatsoever, including without limitation if you breach these Terms. Upon
termination, your right to use the Application will immediately cease.

9.2 All provisions of the Terms which by their nature should survive termination
shall survive termination, including, without limitation, ownership provisions,
warranty disclaimers, indemnity, and limitations of liability.

## 10. Changes to the Application

We reserve the right to withdraw or amend the Application, and any service or
material we provide via the Application, in our sole discretion without notice.
We will not be liable if, for any reason, all or any part of the Application is
unavailable at any time or for any period. From time to time, we may restrict
access to some parts of the Application, or the entire Application, to users.

## 11. Modifications to the Terms

We may revise and update these Terms from time to time in our sole discretion.
All changes are effective immediately when we post them. Your continued use of
the Application following the posting of revised Terms means that you accept and
agree to the changes. You are expected to check this page frequently so you are
aware of any changes, as they are binding on you.

## 12. Governing Law and Jurisdiction

These Terms and any dispute or claim arising out of or related to them, their
subject matter or their formation (in each case, including non-contractual
disputes or claims) shall be governed by and construed in accordance with the
laws of the Province of Ontario, Canada, without giving effect to any choice or
conflict of law provision or rule. Any legal suit, action, or proceeding arising
out of, or related to, these Terms or the Application shall be instituted
exclusively in the courts of Ontario, Canada. You waive any and all objections
to the exercise of jurisdiction over you by such courts and to venue in such
courts.

## 13. Waiver and Severability

No waiver by the Company of any term or condition set out in these Terms shall
be deemed a further or continuing waiver of such term or condition or a waiver
of any other term or condition, and any failure of the Company to assert a right
or provision under these Terms shall not constitute a waiver of such right or
provision.

If any provision of these Terms is held by a court or other tribunal of
competent jurisdiction to be invalid, illegal, or unenforceable for any reason,
such provision shall be eliminated or limited to the minimum extent such that
the remaining provisions of the Terms will continue in full force and effect.

## 14. Entire Agreement

These Terms, our Privacy Policy, and any other legal notices published by us on
the Application, shall constitute the entire agreement between you and Sovilon
Software Inc. regarding the Application and Service.

## 15. Contact Us

For any questions about these Terms, please contact us at mailing address:

Sovilon Software Inc.

Sheridan College - EDGE Entrepreneurship Room B290, Hazel

McCallion Campus ℅ Sovilon Software Inc., Michael Nolivos 4226 Duke of York Blvd

Mississauga, ON L5B 0G5 Canada

or via the sovilon software inc. website.
